import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deleteRoles as apiDeleteRoles } from "../../api/apiRoles";
import { toast } from "react-hot-toast";
import getErrorMessageFromAxiosError from "../../utils/parseError";


export function useDeleteRoles() {
    const queryClient = useQueryClient();

    const {
        mutate: deleteRoles,
        isPending: isDelete,
        data: results,
        error,
    } = useMutation({
        mutationFn: (req) => apiDeleteRoles(req),
        onSuccess: (response) => {
            toast.success(response.message);
            queryClient.invalidateQueries({
                queryKey: ["roles"],
            });
        },
        onError: (err) => {
            const msg = getErrorMessageFromAxiosError(err, "Something Wont Wrong!");
            toast.error(msg);
        },

    });

    return { deleteRoles, isDelete, error, results };
}
